import React, { useRef } from 'react';
import * as S from './Canvas.style';
import { useResizeObserver } from '../../hooks/useResizeObserver';
import { Canvas } from '../Canvas/Canvas.component';

interface ResponsiveCanvasProps {
  draw: (ctx: CanvasRenderingContext2D, width: number, height: number, context: unknown) => void;
  options: {
    context: unknown;
    predraw: (
      ctx: CanvasRenderingContext2D,
      canvas: HTMLCanvasElement,
      size: { height: number; width: number },
    ) => void;
    postdraw: () => void;
  };
}

export const ResponsiveCanvas = ({ draw, options }: ResponsiveCanvasProps) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const size = useResizeObserver(containerRef);

  return (
    <S.CanvasSpace ref={containerRef}>
      <Canvas size={size} draw={draw} options={options} />
    </S.CanvasSpace>
  );
};
